<div class="inner">
  <div class="settings">
    <qai-call-button
      [label]="('call.SETTINGS' | transloco)"
      kind="tertiary"
      icon="settings"
      (clicked)="handleSettingsClick()"
    />

    <qai-call-button
      [label]="('call.CAPTIONS_LABEL' | transloco)"
      [kind]="isCaptionsOn ? 'tertiary' : 'destructive'"
      [icon]="isCaptionsOn ? 'captions' : 'captions-off'"
      (clicked)="handleCaptionsClick()"
    />
  </div>

  <div class="controls">
    <ng-content select="app-visual-aid-call-controls" />
  </div>
</div>
